import HttpCodes from '../enums/HttpCodes';
import T from 'i18n-react';

// Redux
import { store } from '../App';
import { openDialogErrorAction } from '../store/error/ErrorActions';
import { redirectUserLoginAction } from '../store/user/UserActions';
// Enum
import PAGES from '../enums/PageEnum';

/**
 * Class permettant de créer des erreurs personnalisées pour l'api
 */
class ApiError extends Error {
    constructor(errorObject) {
        super();
        this.statusText = errorObject.statusText;
        this.status = errorObject.status;
        this.url = errorObject.url;
        this.stack = (new Error()).stack;
    }
}

class WebService {

    /**
     * Méthode pour faire les appels WS
     * @param url
     * @param method
     * @param body
     * @returns {Promise.<TResult>}
     */
    call(url, method, body) {
        const jsonHeaders = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            // 'Token': token,
        };

        const requestDetail = {
            method: method,
            credentials: 'include',
            dataType: 'json',
            headers: jsonHeaders
        };

        if (body) {
            requestDetail.body = JSON.stringify(body);
        }
        return fetch(url, requestDetail)
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(new ApiError({
                        statusText: response.statusText,
                        status: response.status,
                        url
                    }));
                }

                // Retourne la réponse sous forme de json
                // le catch gère le cas ou il n'y aurait pas de
                // réponse
                return response.json().catch(err => ({}));
            })
            .catch(this._handleErrors);
    }

    /**
     * Méthode pour télécharger un fichier depuis un WS
     */
    downloadFile(url, method, success) {
        var xhr = new XMLHttpRequest();
        xhr.open(method, url, true);
        xhr.responseType = 'blob';
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if(xhr.status === HttpCodes.OK) {
                    var fileName = xhr.getResponseHeader("Content-Disposition").match(/[^;=\n]*=((['"]).*?\2|[^;\n]*)/i)[1];
                    success(xhr.response, fileName);
                } else if (xhr.status === HttpCodes.UNAUTHORIZED || xhr.status === HttpCodes.FORBIDDEN) {
                    store.dispatch(redirectUserLoginAction);
                } else {
                    store.dispatch(openDialogErrorAction(T.translate('errors.internalServerError'), HttpCodes.INTERNAL_SERVER_ERROR));
                }
            }
        };
        xhr.onerror = function(){
            store.dispatch(openDialogErrorAction(T.translate('errors.internalServerError'), HttpCodes.INTERNAL_SERVER_ERROR));
        };
        xhr.send(null);
    }

    uploadFile(url, formData) {
        const options = {
            method : 'POST',
            body : formData
        };
        return fetch(url, options).then(
            (response) => {
            if (!response.ok) {
                return Promise.reject(new ApiError({
                    statusText: response.statusText,
                    status: response.status,
                    url
                }));
            }

            // Retourne la réponse sous forme de json
            // le catch gère le cas ou il n'y aurait pas de
            // réponse
            return response.json().catch(err => ({}));
            })
        .catch(this._handleErrors);
    }


    /**
     * Gère les erreurs de l'api
     * @param error
     */
    _handleErrors(error) {
        switch (error.status) {
            case HttpCodes.NOT_FOUND:
                throw error;
            case HttpCodes.BAD_REQUEST:
                throw error;
            case HttpCodes.UNAUTHORIZED:
            case HttpCodes.FORBIDDEN: {
                if (!error.url.includes(PAGES.LOGIN_PAGE)) {
                    store.dispatch(redirectUserLoginAction);
                }
                throw error;
            }
            case HttpCodes.INTERNAL_SERVER_ERROR:
                store.dispatch(openDialogErrorAction(T.translate('errors.internalServerError'), HttpCodes.INTERNAL_SERVER_ERROR));
                throw error;
            default:
                throw error;
        }
    }

}

export default new WebService();



// WEBPACK FOOTER //
// ./src/services/WebService.js